import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { uniq } from '@finect/front-utils/uniq';
import { getResourcePath } from '../Routes';
export var getAuthorBadges = function getAuthorBadges(user) {
  var _user$organizations = user.organizations,
    organizations = _user$organizations === void 0 ? [] : _user$organizations;
  return uniq(organizations.map(function (_ref) {
    var _ref$badges = _ref.badges,
      badges = _ref$badges === void 0 ? [] : _ref$badges;
    return badges;
  }).flatMap(function (item) {
    return item;
  }));
};
export var getProfilePath = function getProfilePath(theme, profile) {
  var type = profile.type,
    subtype = profile.subtype,
    alias = profile.alias;
  var scene = ['user'].includes(subtype || type) ? 'UserProfile' : 'GroupProfile';
  return getResourcePath(theme, scene, {
    profile: alias,
    alias: alias
  });
};
export var isOrganizationAdviser = function isOrganizationAdviser(organization) {
  return (organization.roles || []).includes('adviser');
};
export var isUserAdviser = function isUserAdviser(user) {
  return user.organizations.some(function (organization) {
    return isOrganizationAdviser(organization);
  });
};
export var isProfileAdviser = function isProfileAdviser(profile) {
  return ['company'].includes(profile.subtype) ? profile.features.adviser : isUserAdviser(profile);
};